import { DownOutlined } from '@ant-design/icons'

export const CustomExpandIcon = ({ isActive }: { isActive?: boolean }) => {
  return (
    <DownOutlined
      style={{
        transform: isActive ? 'rotate(180deg)' : 'rotate(0deg)',
        transition: '0.2s',
        marginTop: '70%',
      }}
    />
  )
}
